import React, { useState, useEffect } from 'react';
import { Badge, Button, ModalFooter, Spinner } from 'reactstrap';
import { ref, update, get, child, equalTo, orderByChild, push, set, query } from 'firebase/database';
import { getStorage, ref as storageRef, deleteObject } from 'firebase/storage';
import { db } from '../../../../firebase'; // Assuming your Firebase setup
import DataTable from '../../../common/Table';
import AddModel from '../../../common/AddModel';
import { errorToast, successToast } from '../../../common/toast';
import { convertFirebaseTimestamp, sendLoginDetailsEmail, sendResendOtpEmail } from '../../../common/commonFunction';
import moment from 'moment';

const PendingUsers = () => {
  const storage = getStorage();
  const [isAddModel, setIsAddModel] = useState(false);
  const [isViewModel, setIsViewModel] = useState(false);
  const [users, setUsers] = useState([]);
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userConfirmLoading, setUserConfirmLoading] = useState(false);

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Number",
      accessor: "number",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Registration",
      accessor: "registrationDate",
      filter: false,
      Cell: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "-"
      },
    },
    {
      Header: "Start_Date",
      accessor: "startDate",
      Cell: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "-"
      },
    },
    {
      Header: "End_Date",
      accessor: "endDate",
      Cell: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "-"
      },
    },
    {
      Header: "Caller",
      accessor: "caller",
      Cell: ({ value }) => {
        return value?.label;
      },
    },
  ];

  const handleView = (user) => {
    setEditData(user);
    setIsViewModel(true);
  };

  const handleEdit = (user) => {
    setEditData(user);
    setIsAddModel(true);
  };

  const handleDelete = async (user) => {
    if (window.confirm(`Are you sure you want to delete ${user.name}?`)) {
      try {
        await deleteObject(storageRef(storage, `userAgreements/${user.id}/User_Agreement.pdf`));
        await update(ref(db, `users/${user.id}`), null); // Delete the user from Realtime Database
        successToast(`${user.name} has been deleted!`);
        fetchUsers();
      } catch (error) {
        errorToast("Error deleting user: " + error.message);
      }
    }
  };

  const actionButtons = [
    {
      icon: 'bi bi-eye',
      onClick: handleView,
    },
    {
      icon: 'bi bi-pencil',
      onClick: handleEdit,
    },
    {
      icon: 'bi bi-trash',
      color: 'danger',
      onClick: handleDelete,
    },
  ];

  const fetchUsers = async () => {
    setIsLoading(true);
    let userData = [];

    const usersRef = ref(db, 'users');
    const queryRef = query(usersRef, orderByChild('registrationDate'));
    const snapshot = await get(queryRef);
    if (snapshot.exists()) {
      snapshot.forEach((userSnapshot) => {
        const user = userSnapshot.val();
        if (user.status === "OTP Done") {
          userData.push({ id: userSnapshot.key, ...user });
        }
      });
    }
    // await checkAndBlockUsers(userData);
    setUsers(userData.reverse());
    setIsLoading(false);
  }

  const userConfirm = async () => {
    setUserConfirmLoading(true);
    try {
      const userRef = ref(db, `users/${editData.id}`);
      await update(userRef, {
        status: 'Done',
        userName: editData?.email,
        password: editData?.number,
      });

      const reportRef = ref(db, `qcReports`);
      const newReportRef = push(reportRef); // Use push on the reference
      const newReportKey = newReportRef.key; // Get the new key

      await set(newReportRef, {
        userId: editData.id,
        name: editData.name,
        email: editData.email,
        number: editData.number,
        startDate: "",
        endDate: "",
        totalForms: editData?.plan?.label,
        savedForms: 0,
        submittedForms: 0,
        wrongForms: 0,
        rightForms: 0,
        registrationDate: editData?.registrationDate,
      });

      sendLoginDetailsEmail(editData);
      setIsViewModel(false);
      fetchUsers();
    } catch (error) {
      errorToast("Error confirming user: " + error.message);
    } finally {
      setUserConfirmLoading(false);
    }
  };

  const userReject = async () => {
    setIsViewModel(false);
    try {
      const pdfRef = storageRef(storage, `userAgreements/${editData?.id}/User_Agreement.pdf`);
      await deleteObject(pdfRef);

      const userRef = ref(db, `users/${editData?.id}`);
      await update(userRef, {
        pdfAgreementUrl: "",
        status: 'Pending',
      });
      sendResendOtpEmail(editData);
      fetchUsers();
    } catch (error) {
      errorToast("Error rejecting agreement: ", error);
    }
  };

  const checkAndBlockUsers = async (userData) => {
    const currentTime = new Date();
    const twelvePM = new Date();
    twelvePM.setHours(12, 0, 0, 0);

    for (const user of userData) {
      const endDate = user?.endDate?.seconds ? new Date(user.endDate.seconds * 1000) : null;

      if (endDate) {
        if (
          endDate.toDateString() === currentTime.toDateString() &&
          currentTime > twelvePM
        ) {
          const userRef = ref(db, `users/${user.id}`);
          await update(userRef, { status: "Blocked" });
        }
      }
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      {/* <Button onClick={() => sendRegistrationEmail({
        email: "ansariabul01@gmail.com",
        name: "abul",
      })}>
        send email
      </Button > */}

      <DataTable
        title={"Pending Users"}
        // isAddNew={() => {
        //   setEditData();
        //   setIsAddModel(true)
        // }}
        isLoading={isLoading}
        tableData={users}
        columns={columns}
        actionButtons={actionButtons}
      />

      {/* {
        isAddModel &&
        <AddModel
          title={editData && Object.entries(editData)?.length ? "Edit User" : "Add User"}
          isAddModel={isAddModel}
          setIsAddModel={setIsAddModel}
          message={
            <AddNewUser
              fetchUsers={fetchUsers}
              setIsAddModel={setIsAddModel}
              editData={editData}
            />
          }
        />
      } */}
      {
        isViewModel &&
        <AddModel
          title={`User Agreement PDF (OTP:- ${editData?.otp})`}
          isAddModel={isViewModel}
          setIsAddModel={setIsViewModel}
          message={
            <>
              {!editData?.pdfAgreementUrl ? "No Agreement Found" : (
                <>
                  <iframe
                    src={editData?.pdfAgreementUrl}
                    width="100%"
                    height="400px"
                    title="User Agreement PDF"
                  />
                  <ModalFooter>
                    <Button color="success" onClick={userConfirm} disabled={userConfirmLoading}>
                      {userConfirmLoading && <Spinner size="sm" className="me-2" />}
                      Confirm
                    </Button>
                    <Button color="secondary" onClick={userReject}>
                      Resend
                    </Button>
                  </ModalFooter></>
              )}
            </>
          }
        />
      }
    </>
  )
}

export default PendingUsers